<tui-root>
  <wl-page-nav>
    <router-outlet />
  </wl-page-nav>
</tui-root>
